/**
 * Royal Tulip Tbilisi media.
 * Gallery prefers Gimmonix `/hotelImages` at runtime; local copies under
 * /public/campaigns/royal-tulip-tbilisi/ are the fallback.
 */
export const ROYAL_TULIP_HERO_IMAGE = "/campaigns/royal-tulip-tbilisi/hero.jpg";

export const ROYAL_TULIP_PROMO_VIDEO = null;

const LOCAL_GALLERY = [
  { file: "hero.jpg", altHe: "Royal Tulip Kosher Hotel טביליסי — מבט כללי" },
  { file: "gallery-02.jpg", altHe: "Royal Tulip טביליסי — לובי המלון" },
  { file: "gallery-03.jpg", altHe: "Royal Tulip טביליסי — חדר אירוח" },
  { file: "gallery-04.jpg", altHe: "Royal Tulip טביליסי — חדר משפחה" },
  { file: "gallery-05.jpg", altHe: "Royal Tulip טביליסי — בריכה ונוף" },
  { file: "gallery-06.jpg", altHe: "Royal Tulip טביליסי — פינת ישיבה" },
  { file: "gallery-07.jpg", altHe: "Royal Tulip טביליסי — חלל המלון" },
  { file: "gallery-08.jpg", altHe: "Royal Tulip טביליסי — נוף מהמלון" },
  { file: "gallery-09.jpg", altHe: "Royal Tulip טביליסי — פינת אוכל" },
];

export const ROYAL_TULIP_LOCAL_GALLERY_IMAGES = LOCAL_GALLERY.map((image, index) => ({
  id: `gallery-${index + 1}`,
  file: image.file,
  src: index === 0 ? ROYAL_TULIP_HERO_IMAGE : `/campaigns/royal-tulip-tbilisi/${image.file}`,
  altHe: image.altHe,
}));

export function mapGimmonixUrlsToGallery(urls) {
  const list = Array.isArray(urls) ? urls.filter(Boolean) : [];
  return list.map((src, index) => ({
    id: `gimmonix-${index + 1}`,
    file: `gimmonix-${index + 1}`,
    src,
    altHe: `Royal Tulip Kosher Hotel טביליסי — תמונה ${index + 1}`,
  }));
}
